module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"mustNotBeEmpty":"Please select a value","invalidValue":"Invalid value"},"fr":{"mustNotBeEmpty":"Veuillez sélectionner une valeur","invalidValue":"Valeur invalide"}}')
  delete Component.options._Ctor
}
